import Vue from 'vue';
import routerPageHook from '@assets/js/routerPageHook.js'

export default {
    name: 'e404',
    data() {
        return {
            template: '<main></main>',
        };
    },
    ...routerPageHook,
    render(createElement) {
        return Vue.compile(this.template).render.call(this, createElement);
    },
};


// WEBPACK FOOTER //
// ./src/templates/pages/404/index.js